import { PropsWithChildren, RefObject, memo, type HTMLAttributes, type ReactNode } from 'react';

import { css, cx, type Styles } from '@flipster/styled-system/css';
import { badge, type BadgeVariantProps } from '@flipster/styled-system/recipes';

type BaseProps = PropsWithChildren<{
  // variants
  type?: BadgeVariantProps['type'];
  color?: BadgeVariantProps['color'];
  // slots
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  css?: Styles;
  ref?: RefObject<HTMLDivElement>;
}>;
export type BadgeProps = BaseProps & Omit<HTMLAttributes<HTMLDivElement>, keyof BaseProps>;

export const Badge = memo((props: BadgeProps) => {
  const { ref, type, color, leadingIcon, trailingIcon, children, css: cssProps, ...rest } = props;
  const classes = badge({ type, color });

  return (
    <div ref={ref} className={cx(classes.root, css(cssProps))} {...rest}>
      {leadingIcon && <div className={classes.icon}>{leadingIcon}</div>}
      {children && <span>{children}</span>}
      {trailingIcon && <div className={classes.icon}>{trailingIcon}</div>}
    </div>
  );
});
Badge.displayName = 'Badge';
